export default __webpack_public_path__ + "static/media/coming-soon-v2-bg.b50e50f5.jpg";